import React from 'react';
import { GenericSelect } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import { isRequired } from '../../../utils/validation';
import { TURNOVER_CONTENT } from './DropdownContent';

const AccountTurnoverDetails = () => (
  <Content>
    {({
      accountDetailsAnnualTurnoverTitle = '',
      accountDetailsFormErrorSelect = '',
      accountDetailsAnnualTurnoverTitleHelpText = ''
    }) => (
      <Field name="annualTurnover" subscription={{ touched: true, error: true }}>
        {({ meta: { touched, error } }) => (
          <GenericFieldWrapper
            inputId="annualTurnover"
            title={accountDetailsAnnualTurnoverTitle}
            validationMessage={touched && !!error ? accountDetailsFormErrorSelect : ''}
            description={accountDetailsAnnualTurnoverTitleHelpText}
          >
            <Field name="annualTurnover" validate={isRequired}>
              {({ input }) => (
                <GenericSelect
                  name="annualTurnover"
                  {...input}
                  items={TURNOVER_CONTENT}
                  selectedId={!input.value ? null : input.value}
                  onChange={selectedId => {
                    input.onChange(selectedId);
                  }}
                />
              )}
            </Field>
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);
export default AccountTurnoverDetails;
